module.exports = __webpack_public_path__ + "static/media/1_en.efc5216b.png";